import { createFileRoute } from '@tanstack/react-router'
import { CreateTicket } from '../../../pages/CreateTicket'

export const Route = createFileRoute('/helpdesk/tickets/new')({
  component: CreateTicket,
})